<mat-card appearance="outlined" class="cardForm">
  <mat-card-header>
    <mat-card-title class="cardTitle">
      <h1>{{ "orders.create.title" | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-progress-bar
      *ngIf="isLoading"
      class="progress-bar"
      mode="indeterminate"
      color="accent"
    >
    </mat-progress-bar>

    <div class="introduction">
      <p>
        Complétez le formulaire ci-dessous pour passer votre commande en ligne.
      </p>

      <p>
        En cas de transport urgent, merci de bien valider la commande par appel
        téléphonique au numéro habituel.
      </p>
    </div>

    <form
      [formGroup]="clientForm"
      *ngIf="!isAdminWithOneClient && !isLoading"
      class="formClient"
    >
    <section>
      <h3>
        Agence <span class="red">*</span>
      </h3>

      <app-autocomplete
        [control]="getClientControl('client')"
        [list]="clients"
        label="users.edit.clients.select.label"
      >
      </app-autocomplete>
    </section>
    </form>

    <form
      class="edit-form"
      [formGroup]="editForm"
      (submit)="onSubmit()"
      *ngIf="editForm && canChooseValue"
    >
      <section *ngIf="canCreateTour()">
        <h3>
          {{ "orders.create.orderType" | translate }}<span class="red">*</span>
        </h3>
        <mat-radio-group formControlName="type">
          <mat-radio-button value="isClient">Classique</mat-radio-button>
          <mat-radio-button value="isTour">Tournée</mat-radio-button>
        </mat-radio-group>
      </section>

      <section *ngIf="isTour()">
        <h3>
          {{ "orders.create.name.title" | translate }}
        </h3>
        <mat-form-field>
          <mat-label>{{ "orders.create.name.label" | translate }}</mat-label>
          <input type="text" matInput formControlName="name" />
        </mat-form-field>
      </section>

      <section *ngIf="isTour() && isControlSet('code')">
        <h3>
          {{ "orders.create.code.title" | translate }}
        </h3>
        <mat-form-field>
          <mat-label>{{ "orders.create.code.label" | translate }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="code"
            [maxlength]="codeMaxLength"
          />
          <mat-error>
            {{ "orders.create.code.errorMessage" | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section *ngIf="isTour()">
        <h3>{{ "orders.create.tourInfo" | translate }}</h3>
        <div class="tourInfoFields">
          <div>
            <app-autocomplete
              label="orders.create.driver"
              [control]="getControl('driver')"
              [list]="drivers"
            >
            </app-autocomplete>
          </div>

          <div class="tourInfoFields" *ngIf="canEditTourPrices">
            <mat-form-field>
              <mat-label>{{ "orders.create.price" | translate }}</mat-label>
              <input type="number" min="0" matInput formControlName="price" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{
                "orders.create.extraStepPrice" | translate
              }}</mat-label>
              <input
                type="number"
                min="0"
                matInput
                formControlName="extraStepPrice"
              />
            </mat-form-field>
          </div>
        </div>
      </section>

      <div class="ordererSiteSection">
        <section>
          <h3>
            Etablissement ({{ "orders.create.site.label" | translate }})
            <span class="red">*</span>
          </h3>
          <p *ngIf="!selectedClient && !isAdminWithOneClient" class="info-message">
            Veuillez d'abord sélectionner une agence ci-dessus
          </p>
          <app-autocomplete
            *ngIf="selectedClient || isAdminWithOneClient"
            [canString]="isDispatcher ? true : false"
            label="orders.create.site.label"
            class="site-field"
            [control]="getControl('site')"
            [list]="filteredSites"
            [setSites]="filteredSites"
            errorMsg="orders.create.site.errorMessage"
          >
          </app-autocomplete>
        </section>

        <section class="ordererSection">
          <h3>Demandeur</h3>
          <div class="ordererFields">
            <mat-form-field class="ordererName-field">
              <mat-label>{{
                "orders.create.ordererName.label" | translate
              }}</mat-label>
              <input matInput formControlName="ordererName" />
              <mat-error>
                {{ "orders.create.ordererName.errorMessage" | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="ordererPhone-field">
              <mat-label>{{
                "orders.create.ordererPhone.label" | translate
              }}</mat-label>
              <input matInput formControlName="ordererPhone" />
              <mat-error
                >{{ "orders.create.ordererPhone.errorMessage" | translate }}
              </mat-error>
            </mat-form-field>

            <!-- <mat-form-field class="callDate-field">
              <mat-label>Heure d'appel</mat-label>
              <input id="inputTime" type="time" matInput formControlName="callDate">
            </mat-form-field> -->
          </div>
        </section>
      </div>

      <fieldset formGroupName="sender" class="fieldsetSender">
        <legend class="titleLegend">
          <span *ngIf="!isTour()">Lieu d'enlèvement -</span>Étape 1<span
            class="red"
            >*</span
          >
        </legend>
        <section>
          <h3>Adresse <span class="red">*</span></h3>
          <app-autocomplete
            class="site-field"
            [control]="editForm.get('sender').get('address')"
            [list]="senders"
            errorMsg="orders.create.sender.errorMessage"
            [canString]="canAddOtherAddress"
            [setSites]="senders"
          >
          </app-autocomplete>
        </section>

        <section *ngIf="editForm.get('sender').get('address').value">
          <h3>
            {{ "orders.create.senderService.label" | translate }}
            <span class="red">*</span>
          </h3>

          <ng-container
            *ngIf="
              isTypeOf('string', editForm.get('sender').get('address').value);
              else noString
            "
          >
            <app-autocomplete-text
              class="site-field"
              [control]="editForm.get('sender').get('service')"
              [list]="[]"
              errorMsg="orders.create.senderService.errorMessage"
            >
            </app-autocomplete-text>
          </ng-container>

          <ng-template #noString>
            <app-autocomplete-text
              class="site-field"
              [control]="editForm.get('sender').get('service')"
              [list]="
                editForm.get('sender').get('address').value?.services?.sort()
              "
              errorMsg="orders.create.senderService.errorMessage"
            >
            </app-autocomplete-text>
          </ng-template>
        </section>

        <section>
          <h3>{{ "orders.create.ordererComment.title" | translate }}</h3>
          <mat-form-field class="comment-field">
            <textarea
              matInput
              rows="5"
              formControlName="ordererComment"
            ></textarea>
            <mat-error
              >{{ "orders.create.ordererComment.error" | translate }}
            </mat-error>
          </mat-form-field>
        </section>
      </fieldset>

      <section *ngIf="isControlSet('receivers')">
        <mat-list formArrayName="receivers">
          <mat-list-item
            class="oneReceiver"
            *ngFor="let control of getArray('receivers').controls; index as i"
            [formGroupName]="i"
          >
            <div matLine>
              <fieldset>
                <legend class="titleLegend">
                  <span
                    *ngIf="
                      !isTour() && getArray('receivers').controls.length === 1
                    "
                    >Lieu de livraison -
                  </span>
                  <span>Étape {{ i + 2 }} </span>
                  <span *ngIf="i === 0" class="red">*</span>
                </legend>

                <section
                  *ngIf="!isTour() && getArray('receivers').controls.length > 1"
                >
                  <mat-radio-group formControlName="type">
                    <mat-radio-button value="isDelivery"
                      >Livraison</mat-radio-button
                    >
                    <mat-radio-button value="isPickup"
                      >Enlèvement</mat-radio-button
                    >
                  </mat-radio-group>
                </section>

                <section>
                  <h3>Adresse <span class="red">*</span></h3>
                  <app-autocomplete
                    class="site-field"
                    [control]="control.get('address')"
                    [list]="receivers"
                    errorMsg="orders.create.receiver.errorMessage"
                    [canString]="canAddOtherAddress"
                    [setSites]="receivers"
                  >
                  </app-autocomplete>
                </section>

                <section *ngIf="control.get('address').value">
                  <h3>
                    {{ "orders.create.receiverService.label" | translate }}
                    <span class="red">*</span>
                  </h3>

                  <ng-container
                    *ngIf="
                      isTypeOf('string', control.get('address').value);
                      else noString
                    "
                  >
                    <app-autocomplete-text
                      class="site-field"
                      [control]="control.get('service')"
                      [list]="[]"
                      errorMsg="orders.create.receiverService.errorMessage"
                    >
                    </app-autocomplete-text>
                  </ng-container>

                  <ng-template #noString>
                    <app-autocomplete-text
                      class="site-field"
                      [control]="control.get('service')"
                      [list]="control.get('address').value?.services"
                      errorMsg="orders.create.receiverService.errorMessage"
                    >
                    </app-autocomplete-text>
                  </ng-template>
                </section>

                <section>
                  <h3>
                    {{ "orders.create.ordererComment.title" | translate }}
                  </h3>
                  <mat-form-field class="comment-field">
                    <textarea
                      matInput
                      rows="5"
                      formControlName="ordererComment"
                    ></textarea>
                    <mat-error
                      >{{ "orders.create.ordererComment.error" | translate }}
                    </mat-error>
                  </mat-form-field>
                </section>

                <section *ngIf="isControlPatientSet(i)">
                  <fieldset class="patients-list">
                    <legend>
                      <h3>{{ "orders.create.patients.title" | translate }}</h3>
                    </legend>
                    <mat-list formArrayName="patients">
                      <mat-list-item
                        *ngFor="
                          let control of getArrayPatients(i).controls;
                          index as i2
                        "
                        [formGroupName]="i2"
                        class="listPatients"
                      >
                        <div matLine class="onePatientLine">
                          <mat-form-field>
                            <mat-label>{{
                              "orders.create.patients.firstname.label"
                                | translate
                            }}</mat-label>
                            <input matInput formControlName="firstname" />
                            <mat-error>{{
                              "orders.create.patients.firstname.errorMessage"
                                | translate
                            }}</mat-error>
                          </mat-form-field>

                          <mat-form-field>
                            <mat-label>{{
                              "orders.create.patients.birthname.label"
                                | translate
                            }}</mat-label>
                            <input matInput formControlName="birthname" />
                            <mat-error>{{
                              "orders.create.patients.birthname.errorMessage"
                                | translate
                            }}</mat-error>
                          </mat-form-field>

                          <mat-form-field>
                            <mat-label>{{
                              "orders.create.patients.lastname.label"
                                | translate
                            }}</mat-label>
                            <input matInput formControlName="lastname" />
                            <mat-error>{{
                              "orders.create.patients.lastname.errorMessage"
                                | translate
                            }}</mat-error>
                          </mat-form-field>

                          <mat-form-field class="birthdate-field">
                            <mat-label>{{
                              "orders.create.patients.birthdate.label"
                                | translate
                            }}</mat-label>
                            <input
                              matInput
                              formControlName="birthdate"
                              [matDatepicker]="birthdatePicker"
                              (click)="resetBirthDate(control)"
                            />
                            <mat-datepicker-toggle
                              matSuffix
                              [for]="birthdatePicker"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #birthdatePicker></mat-datepicker>
                            <mat-error>{{
                              "orders.create.patients.birthdate.errorMessage"
                                | translate
                            }}</mat-error>
                          </mat-form-field>

                          <mat-form-field class="ippField">
                            <mat-label>IPP/SERVICE/UF</mat-label>
                            <input
                              matInput
                              formControlName="ipp"
                              [matTooltip]="control.value.ipp"
                            />
                            <mat-error>Max 50 caractères</mat-error>
                          </mat-form-field>

                          <mat-form-field>
                            <mat-label>{{
                              "orders.create.patients.productType.label"
                                | translate
                            }}</mat-label>
                            <select
                              matNativeControl
                              formControlName="productType"
                              required
                            >
                              <option value="CGR">CGR</option>
                              <option value="Plaquettes">
                                Plaquettes (CPA)
                              </option>
                              <option value="Plasma">
                                PFC (Plasma Frais Congelé)
                              </option>
                              <option value="PlasmaPFD">
                                PFD (Plasma Frais Décongelé)
                              </option>
                            </select>
                            <mat-error>{{
                              "orders.create.patients.productType.errorMessage"
                                | translate
                            }}</mat-error>
                          </mat-form-field>

                          <mat-form-field class="quantityField">
                            <mat-label>{{
                              "orders.create.patients.quantity.label"
                                | translate
                            }}</mat-label>
                            <input
                              matInput
                              type="number"
                              formControlName="quantity"
                            />
                            <mat-error>{{
                              "orders.create.patients.quantity.errorMessage"
                                | translate
                            }}</mat-error>
                          </mat-form-field>

                          <div>
                            <button
                              type="button"
                              mat-icon-button
                              color="primary"
                              (click)="onCopyPatient(i, control)"
                            >
                              <mat-icon aria-label="delete"
                                >content_copy</mat-icon
                              >
                            </button>

                            <button
                              type="button"
                              mat-icon-button
                              color="primary"
                              (click)="onRemovePatient(i, i2)"
                            >
                              <mat-icon aria-label="delete">delete</mat-icon>
                            </button>
                          </div>
                        </div>
                      </mat-list-item>
                      <mat-list-item>
                        <button
                          type="button"
                          mat-icon-button
                          color="primary"
                          (click)="onAddPatient(i)"
                          matTooltip="Ajouter un patient"
                        >
                          <mat-icon aria-label="Add">add</mat-icon>
                        </button>
                      </mat-list-item>
                    </mat-list>
                  </fieldset>
                </section>
              </fieldset>
            </div>
            <button
              *ngIf="(isTour() && getArray('receivers').length > 1) || i !== 0"
              type="button"
              matTooltip="Retirer
              le destinataire"
              mat-icon-button
              color="primary"
              (click)="onRemoveReceiver(i)"
            >
              <mat-icon aria-label="delete">delete</mat-icon>
            </button>
          </mat-list-item>
          <mat-list-item>
            <button
              type="button"
              mat-icon-button
              color="primary"
              matTooltip="Ajouter un destinataire"
              (click)="onAddReceiver()"
            >
              <mat-icon aria-label="Add">add</mat-icon>
            </button>
          </mat-list-item>
        </mat-list>
      </section>

      <section *ngIf="isControlSet('schedule')" class="date-field">
        <h3>Date, heure de départ souhaitée<span class="red">*</span></h3>
        <mat-list formArrayName="schedule">
          <mat-list-item
            *ngFor="let control of getArray('schedule').controls; index as i"
            [formGroupName]="i"
          >
            <div matLine>
              <mat-form-field class="start-date-field">
                <mat-label>Date</mat-label>
                <input
                  matInput
                  formControlName="startDate"
                  color="primary"
                  [matDatepicker]="startDatePicker"
                  (focus)="startDatePicker.open()"
                  [errorStateMatcher]="confirmValidMatcher"
                  (click)="resetStartDate(control)"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="startDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker> </mat-datepicker>
              </mat-form-field>

              <mat-form-field class="start-time-field">
                <mat-label>Heure</mat-label>
                <input
                  id="inputTime"
                  type="time"
                  matInput
                  formControlName="startTime"
                  [errorStateMatcher]="confirmValidMatcher"
                />
              </mat-form-field>
            </div>
            <div
              matLine
              *ngIf="control.hasError('mismatch')"
              class="schedule-error"
            >
              {{ "orders.create.startDate.errorMessage" | translate }}
            </div>
          </mat-list-item>
        </mat-list>
      </section>

      <section class="date-field">
        <h3>Date, heure de livraison souhaitée</h3>
        <div style="margin-left: 20px">
          <mat-form-field class="start-date-field">
            <mat-label>Date</mat-label>
            <input
              matInput
              formControlName="requestedDeliveryDate"
              color="primary"
              [matDatepicker]="requestedDeliveryDatePicker"
              (focus)="requestedDeliveryDatePicker.open()"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="requestedDeliveryDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #requestedDeliveryDatePicker> </mat-datepicker>
          </mat-form-field>

          <mat-form-field class="start-time-field">
            <mat-label>Heure</mat-label>
            <input
              type="time"
              matInput
              formControlName="requestedDeliveryTime"
            />
          </mat-form-field>
        </div>
      </section>

      <section>
        <h3>
          {{ "orders.create.transportType.label" | translate }}
          <span class="red">*</span>
        </h3>

        <mat-form-field class="devicesChipList">
          <mat-chip-grid #chipList aria-label="Device selection">
            <mat-chip-row
              *ngFor="let selected of transportTypesSelected"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(selected)"
            >
              {{ selected.name }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip-row>
            <input
              placeholder="Sélectionnez un type de produit"
              #deviceInput
              id="deviceChipList"
              [formControl]="transportTypesCtrl"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
            />
            <button
              type="button"
              mat-icon-button
              color="primary"
              *ngIf="transportTypesSelected.length > 0"
              (click)="clearDevicesSelected()"
            >
              <mat-icon class="clearButton" (click)="clearDevicesSelected()"
                >clear</mat-icon
              >
            </button>
          </mat-chip-grid>
          <mat-autocomplete
            class="devicesDropdown"
            #auto="matAutocomplete"
            (optionSelected)="selected($event)"
          >
            <mat-option
              *ngFor="let device of filteredTransportTypes | async"
              [value]="device"
              [disabled]="device.selected"
            >
              {{ device.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </section>

      <section>
        <h3>
          {{ "orders.create.urgencyLevel" | translate }}
          <span class="red">*</span>
        </h3>
        <mat-radio-group
          aria-label="Sélectionnez un niveau d'urgence"
          class="urgency-field"
          formControlName="urgencyLevel"
        >
          <mat-radio-button
            *ngFor="let urgencyLevel of urgencyLevels"
            [value]="urgencyLevel"
            >{{ urgencyLevel.name }}
          </mat-radio-button>
        </mat-radio-group>
      </section>

      <section>
        <h3>Commentaires sur la course</h3>
        <mat-form-field class="comment-field">
          <textarea
            matInput
            rows="5"
            formControlName="ordererComment"
          ></textarea>
          <mat-error
            >{{ "orders.create.ordererComment.error" | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section class="actions">
        <div
          class="checkButton"
          [matTooltip]="invalidMessage"
          [matTooltipDisabled]="
            editForm.valid &&
            transportTypesSelected.length !== 0 &&
            this.editForm.value.receivers[
              this.editForm.value.receivers.length - 1
            ].type !== 'isPickup'
          "
        >
          <button
            *ngIf="!isLoading"
            type="submit"
            mat-raised-button
            color="primary"
            [disabled]="
              editForm.invalid ||
              transportTypesSelected.length === 0 ||
              this.editForm.value.receivers[
                this.editForm.value.receivers.length - 1
              ].type === 'isPickup'
            "
          >
            {{ "global.validateAndCancel.validate" | translate }}
          </button>
        </div>

        <button
          *ngIf="!isLoading"
          type="button"
          mat-raised-button
          color="primary"
          (click)="onFinish()"
        >
          {{ "global.validateAndCancel.cancel" | translate }}
        </button>

        <mat-spinner
          *ngIf="isLoading"
          [diameter]="35"
          color="primary"
        ></mat-spinner>
      </section>
    </form>
  </mat-card-content>
</mat-card>
